import { render } from "./StudyEditHistoryModal.vue?vue&type=template&id=fa371c38&scoped=true"
import script from "./StudyEditHistoryModal.vue?vue&type=script&lang=js"
export * from "./StudyEditHistoryModal.vue?vue&type=script&lang=js"

import "./StudyEditHistoryModal.vue?vue&type=style&index=0&id=fa371c38&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa371c38"]])

export default __exports__